<template>
  <v-dialog v-model="editDialog" persistent width="1024">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" dark class="mx-4" v-bind="attrs" v-on="on">
        Add itom Version
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="text-h5 accent lighten-2">
        {{ formTitle }}
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="6" class="text-center">
              <v-text-field v-model="editedVersion.itom_version" label="Name" />
              <v-text-field v-model="editedVersion.itom_azure_package_name" label="Azure Package" />
            </v-col>
            <v-col cols="12" sm="6" md="6" class="text-center">
              <v-text-field v-model="editedVersion.itom_package_name" label="Package" />
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="computedExpiryDate"
                    label="Support Expires"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="editedVersion.expiry_date"
                  @input="dateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <!-- <v-col cols="12" sm="12" md="12" class="text-center">
              <v-textarea v-model="editedVersion.notes" label="Notes" />
            </v-col> -->
          </v-row>
          <v-row class="my-2">
            <v-subheader>
              Problems
            </v-subheader>
          </v-row>
          <v-divider />
          <v-row>
            <v-col
              v-for="(problem, i) in problems"
              :key="`problem-${i}`"
              cols="12"
              sm="3"
              md="2"
              class="text-center"
            >
              <v-checkbox
                v-model="editedVersion.related_problems"
                :label="problem.itom_problem_ref"
                :value="problem.itom_problem_id"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close"> CANCEL </v-btn>
        <v-btn color="accent" @click="save"> CONFIRM </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import axios from 'axios'
  import { authHeader } from '@/util/helpers'
  import getEnv from '@/util/env'
  // import { get, sync } from 'vuex-pathify'
  const host = getEnv('VUE_APP_API_HOST')
  export default {
    name: 'ItomSoftwareDialog',
    data () {
      return {
        editDialog: false,
        dateMenu: false,
        editedIndex: -1,
        editedVersion: {
          itom_version: '',
          itom_package_name: '',
          itom_azure_package_name: '',
          released: 'n',
          related_problems: [],
          notes: '',
          expiry_date: new Date(new Date().setFullYear(new Date().getFullYear() + 2)).toISOString().substring(0,10)
        },
        defaultVersion: {
          itom_version: '',
          itom_package_name: '',
          itom_azure_package_name: '',
          released: 'n',
          related_problems: [],
          notes: '',
          expiry_date: new Date(new Date().setFullYear(new Date().getFullYear() + 2)).toISOString().substring(0,10)
        },
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Itom Version' : 'Edit Itom Version'
      },
      software () {
        return this.$store.getters['software/itom']
      },
      problems () {
        return this.$store.getters['software/itom_problems']
      },
      computedExpiryDate () {
        if (this.editedVersion.expiry_date !== '') {
          return this.formatDate(this.editedVersion.expiry_date)
        }
        return this.formatDate(Date.now())
      }
    },
    methods: {
      formatDate (date) {
        if (!date) return null
        const d = new Date(date)

        const [year, month, day] = [
          d.getFullYear(),
          d.getMonth() + 1,
          d.getDate(),
        ]
        return `${day}/${month}/${year}`
      },
      editVersion: function (software) {
        let problems = []
        software.itomProblems.forEach(element => {
          problems.push(element.itom_problem_id)
        });
        software.related_problems = problems
        this.editedIndex = this.software.indexOf(software)
        this.editedVersion = Object.assign({}, software)
        this.editedVersion.expiry_date = software.expiry_date.substring(0,10)
        this.editDialog = true
      },
      close () {
        this.editDialog = false
        this.$nextTick(() => {
          this.editedVersion = Object.assign({}, this.defaultVersion)
          this.editedIndex = -1
        })
      },
      save: function() {
        delete this.editedVersion.contracts
        if (this.editedVersion.notes === null) {
          this.editedVersion.notes = ''
        }
        if (this.editedIndex > -1) {
          this.updateVersion()
        } else {
          this.createVersion()
        }
        this.close()
      },
      updateVersion: function () {
        axios
          .put(
            `${host}/v2/itom_software/${this.editedVersion.itom_software_id}`,
            this.editedVersion,
            {
              headers: authHeader(),
            }
          )
          .then(() => {
            this.$snackbar.showMessage({ content: 'Itom version has been updated', color: 'success', timeout: 5000 })
            this.$store.dispatch('software/load')
          })
          .catch((err) => {
            this.$errordialog.showMessage({ content: err.response.data.message, color: 'error', title: 'Oops! Something went wrong.' })
          })
      },
      createVersion: function () {
        axios
          .post(
            `${host}/v2/itom_software/new`,
            this.editedVersion,
            {
              headers: authHeader(),
            }
          )
          .then(() => {
            this.$snackbar.showMessage({ content: 'Itom version has been created', color: 'success', timeout: 5000 })
            this.$store.dispatch('software/load')
          })
          .catch((err) => {
            this.$errordialog.showMessage({ content: err.response.data.message, color: 'error', title: 'Oops! Something went wrong.' })
          })
      }
    }
  }
</script>